import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const HowUploadVideo: React.FC = () => {
  return <div id={"HowUploadVideo"}>
    <h2>
      Как загрузить музыкальные видео
    </h2>
    <p>
      Размещение видеоальбомов полностью идентично процессу публикации аудио. Вот несколько важных деталей:
    </p>
    <ul className={"list-disc"}>
      <li>Загрузить можно видеофайл с расширением avi, mp4, mov, AVI, MP4, MOV. Обложка с соотношением сторон 16:9 и
        размером не менее 1500px
      </li>
      <li>К размещению допускаются только музыкальные видео, куда включаются также официальные live-видео</li>
      <li>Не приветствуется размещение lyric video, бэкстейджа, а также видео со статичным видеорядом.</li>
    </ul>
  </div>;
};
